import { render } from "./VectorCoasterNewItem.vue?vue&type=template&id=b82a3184&scoped=true"
import script from "./VectorCoasterNewItem.vue?vue&type=script&lang=js"
export * from "./VectorCoasterNewItem.vue?vue&type=script&lang=js"

import "./VectorCoasterNewItem.vue?vue&type=style&index=0&id=b82a3184&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b82a3184"]])

export default __exports__